import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import SkeletonJobs from "components/Jobs/SkeletonJobs";
import SkeletonFilters from "components/FilterGroups/SkeletonFilters";
// import "./FilterGroups.scss";
const SkeletonJobSearch = () => {

  return (
    <>
      <Row className="faux-height">
        <Col>
          <SkeletonFilters />
        </Col>
        <Col>
          <div className="results-header">
            <div className="row">
              <div className="col">
                <h2 className="xs-heading">
                  <Skeleton width={250} /> <strong> </strong>{" "}
                </h2>
              </div>
              <div className="col-auto">
                <div>
                  <span>
                    <Skeleton width={80} />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="job-results">
            <ul className="faux-listing">
              <SkeletonJobs />
            </ul>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default SkeletonJobSearch;
